"use client";
import {
  ScrollObserver
} from "../chunk-PROZAJEM.js";
import "../chunk-ZWAYVYGR.js";
import "../chunk-JSBRDJBE.js";
export {
  ScrollObserver as default
};
